import React from 'react'

import { HeroBg, HeroContainer, HeroInnerContainer, HeroLeftContainer, HeroRightContainer, Img, ResumeButton, ScrollArrow, ScrollIndicator, ScrollText, Span, SubTitle, TextLoop, Title } from './HeroStyle'
import {Bio} from '../../data/constants'
import Typewriter from 'typewriter-effect';
import HeroImg from '../../assets/logo/1-512.webp'
import HeroBgAnimation from '../HeroBgAnimation'
import { KeyboardArrowDown } from '@mui/icons-material';

const Hero = () => {
  const scrollToSkills = () => {
    const skillsSection = document.getElementById('skills');
    if (skillsSection) {
      skillsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="about">
        <HeroContainer>
            <HeroBg>
               <HeroBgAnimation />
            </HeroBg>
            <HeroInnerContainer >
                <HeroLeftContainer id="Left">
                    <Title>Hi, I am <br /> {Bio.name}</Title>
                    <TextLoop>
                        I am a
                        <Span>
                            <Typewriter
                                options={{
                                    strings: Bio.roles,
                                    autoStart: true,
                                    loop: true,
                                }}
                            />
                        </Span>
                    </TextLoop>
                    <SubTitle>{Bio.description}</SubTitle>
                    <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton>
                </HeroLeftContainer>

                <HeroRightContainer id="Right">
                    <Img src={HeroImg} alt='Hero' />
                </HeroRightContainer>
            </HeroInnerContainer>

            <ScrollIndicator onClick={scrollToSkills}>
                <ScrollText>Scroll</ScrollText>
                <ScrollArrow>
                    <KeyboardArrowDown />
                </ScrollArrow>
            </ScrollIndicator>

        </HeroContainer>
    </div>
)
}

export default Hero
